import { Routes } from "@angular/router";

import { RootComponent } from "./root.component";

export const rootRouterConfig: Routes = [{ path: "**", component: RootComponent }];
